import React from "react";
import Footer from "../../SharedSection/Footer/Footer";
import Header from "../../SharedSection/Header/Header";
import AboutWork from "../AboutWork/AboutWork";
import Banner from "../Banner/Banner";
import HomeAbout from "../HomeAbout/HomeAbout";
import HomeSkills from "../HomeSkills/HomeSkills";
import ProjectsPortfolio from "../ProjectsPortfolio/ProjectsPortfolio";

const Home = () => {
    return (
        <div className="text-white">
            <Header />
            <Banner />
            <AboutWork />
            <HomeAbout />
            <HomeSkills />
            <ProjectsPortfolio />
            <Footer />
        </div>
    );
};

export default Home;
